import { render, staticRenderFns } from "./WaitingHandle.vue?vue&type=template&id=edc006f2&"
import script from "./WaitingHandle.vue?vue&type=script&lang=js&"
export * from "./WaitingHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports